import { useAccounts } from '@/features/account/hooks/use-accounts'

export const useAccountStatus = () => {
  const { primaryAccount, isLoading } = useAccounts()

  return {
    hasOAuthError: !!primaryAccount?.oauth_error,
    oauthError: primaryAccount?.oauth_error,
    errorTimestamp: primaryAccount?.oauth_error_at,
    isLoading,
    account: primaryAccount,
  }
}
